import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d7{background:var(--shades-white);}.ssr-plugin'
import '.by{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.az{max-width:77.5rem;}.ssr-plugin'
import '.dq{justify-content:stretch;}.ssr-plugin'
import '.dr{position:sticky;}.ssr-plugin'
import '.cp{top:0;}.ssr-plugin'
import '.ds{z-index:10;}.ssr-plugin'
import '.dt{padding-block:1rem;}.ssr-plugin'
import '.du{height:3rem;}.ssr-plugin'
import '.a0{justify-content:space-between;}.ssr-plugin'
import '.dv{flex-wrap:wrap;}.ssr-plugin'
import '.dw{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ax{margin-top:2rem;}.ssr-plugin'
import '.gi{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab g b d7"
      >
        <div className="by a c g b"
        >
          <div className="az a b dq dr cp ds"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dt du a a0 c dv"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dw a b ab ax gi az"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
